import React, { useState } from 'react';
import { User, Bell, Code, ArrowLeft, BarChart3 } from 'lucide-react';
import { useSelector } from 'react-redux';
import ProfileSettings from './ProfileSettings';
import NotificationSettings from './NotificationSettings';
import IntegrationSettings from './IntegrationSettings';
import UsageSettings from './UsageSettings';
import { useStarterPlan } from '../../contexts/OrganizationPlanContext';

export default function SettingsPage({ darkMode }) {
  const [activeSubTab, setActiveSubTab] = useState('Profile');
  const user = useSelector((state) => state.auth.currentUser);
  const starterBypass = useStarterPlan();

  const subTabs = [
    { id: 'Profile', icon: <User size={16} /> },
    { id: 'Notifications', icon: <Bell size={16} /> },
    ...(user?.role === 'org_admin' || starterBypass
      ? [
          { id: 'Current Usage', icon: <BarChart3 size={16} /> },
          { id: 'Integrations', icon: <Code size={16} /> },
        ]
      : [])
  ];

  const renderSubContent = () => {
    switch (activeSubTab) {
      case 'Notifications':
        return <NotificationSettings darkMode={darkMode} />;
      case 'Integrations':
        return <IntegrationSettings darkMode={darkMode} />;
      case 'Current Usage':
        return <UsageSettings darkMode={darkMode} />;
      default:
        return <ProfileSettings darkMode={darkMode} />;
    }
  };

  return (
    <div className="px-8 pb-12 max-w-7xl mx-auto animate-in fade-in duration-500 mt-10">
      {/* INDUSTRIAL BACK BUTTON */}
      <button 
        onClick={() => window.history.back()}
        className="group flex items-center gap-2 text-sm text-gray-500 hover:text-gray-300 transition-colors mb-6"
      >
        <div className="p-1 rounded-full group-hover:bg-gray-800 transition-colors">
          <ArrowLeft size={18} />
        </div>
        <span>Back</span>
      </button>

      <div className="mb-8">
        <h2 className="text-3xl font-bold tracking-tight">Settings</h2>
        <p className="text-gray-500 text-sm mt-1">Manage your account and preferences</p>
      </div>

      <div className="flex flex-col lg:flex-row gap-8">
        {/* LEFT SUB-NAVBAR */}
        <div className="w-full lg:w-64 space-y-1">
          {subTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveSubTab(tab.id)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all ${
                activeSubTab === tab.id 
                  ? 'bg-purple-600/10 text-purple-400 border border-purple-500/20' 
                  : 'text-gray-500 hover:bg-gray-800/50 hover:text-gray-300'
              }`}
            >
              {tab.icon} {tab.id}
            </button>
          ))}
        </div>

        {/* RIGHT CONTENT PANEL */}
        <div className="flex-1">
          {renderSubContent()}
        </div>
      </div>
    </div>
  );
}